import {
} from "antd";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useBreadCrumb from "../hooks/useBreadCrumb";
import PaymentsDataTable from "../components/Payment/PaymentsDataTable";
import useMemberProfilesList from "../hooks/useMemberProfilesList";

function Payments() {
  const location = useLocation();
  useBreadCrumb("Payments", location.pathname, "Payments");

  const memberProfileList = useMemberProfilesList("");

  useEffect(() => {
    const tempMemberProfileData = []
    memberProfileList?.map((member_profile_list_data) => {
      tempMemberProfileData.push({
        "value": member_profile_list_data.member_id,
        "label": `${member_profile_list_data.first_name} ${member_profile_list_data.last_name}`
      })

      return null
    })
  }, [memberProfileList])

  return (
    <div className="dashboard">
      <div className="section_row">
     
        <PaymentsDataTable />
      </div>
    </div>
  );
}

export default Payments
